import React from 'react';

function changeClass(dir) {
  if (dir === 'up') return 'up';
  if (dir === 'down') return 'down';
  return 'flat';
}

export default function NextDayOutlookPanel({ outlook }) {
  if (!outlook) return null;

  return (
    <div className="next-day-panel">
      <div className="next-day-header">
        <span>{outlook.horizon_label || '待披露净值影响参考'}</span>
        {outlook.confidence ? (
          <span className="decision-muted">置信度：{outlook.confidence === 'medium' ? '中' : '低'}</span>
        ) : null}
      </div>

      {!outlook.available ? (
        <p className="decision-muted">{outlook.disclaimer}</p>
      ) : (
        <>
          <div className="next-day-main">
            <div className={`next-day-direction dir-${changeClass(outlook.direction)}`}>
              {outlook.direction_label}
            </div>
            <div className="next-day-range">
              <div className="next-day-range-label">推算区间</div>
              <div className={`next-day-range-value ${changeClass(outlook.direction)}`}>
                {outlook.product_range_text}
              </div>
              <div className="decision-muted next-day-mid">
                中枢约 {outlook.product_mid_text}
                {outlook.tracking_ratio != null ? ` · 跟踪系数 ${outlook.tracking_ratio}` : ''}
              </div>
            </div>
          </div>

          <div className="next-day-meta">
            {outlook.market_date ? <span>行情日 {outlook.market_date}</span> : null}
            {outlook.target_nav_date ? (
              <span>影响净值日 {outlook.target_nav_date}{outlook.confirm_time ? `（${outlook.confirm_time}）` : ''}</span>
            ) : null}
            {outlook.covered_weight_pct != null ? (
              <span>基准覆盖约 {outlook.covered_weight_pct}%</span>
            ) : null}
            {outlook.synthetic_1d_bp != null ? (
              <span>合成基准约 {outlook.synthetic_1d_bp > 0 ? '+' : ''}{outlook.synthetic_1d_bp.toFixed(1)} bp</span>
            ) : null}
          </div>

          {outlook.direction_hint ? (
            <p className="next-day-hint">{outlook.direction_hint}</p>
          ) : null}
        </>
      )}

      {outlook.disclaimer ? (
        <p className="decision-muted next-day-disclaimer">{outlook.disclaimer}</p>
      ) : null}
    </div>
  );
}
